export function getStepperConfig(status) {
    const normalized = (status || '').toLowerCase();
    if (normalized === 'pending') {
        return { activeStep: 1, checkedSteps: [0] };
    }
    if (normalized === 'paid') {
        return { activeStep: 2, checkedSteps: [0, 1, 2] };
    }
    return { activeStep: 0, checkedSteps: [] };
}
